import { render, staticRenderFns } from "./ImpressaoAtestado.vue?vue&type=template&id=762e5039&"
import script from "./ImpressaoAtestado.vue?vue&type=script&lang=js&"
export * from "./ImpressaoAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports